import {Component, OnDestroy, OnInit} from "@angular/core";
import {SubscriptionService} from "../../../subscription/subscription.service";
import {ActivatedRoute, Router} from "@angular/router";
import {BuyService} from "../../../buy/buy.service";
import {Model} from "../../../app.model";
import {CustomerService} from "../../../customer/customer.service";
import {Contact} from "../../../company/company.model";
import {CompanyService} from "../../../company/company.service";
import {WorkflowPartnerService} from "../workflow-partner.service";
import {WorkflowPartnerChangeCuComponent} from "../workflow-partner-change-cu.component";
import {HttpClient} from "@angular/common/http";
import {runInAction} from "mobx";

@Component({
    selector: 'app-workflow-partner-one-downgrade-cu',
    templateUrl: './workflow-partner-one-downgrade-cu.component.html',
    standalone: false
})
export class WorkflowPartnerOneDowngradeCuComponent extends WorkflowPartnerChangeCuComponent implements OnInit, OnDestroy {

  constructor(protected route: ActivatedRoute,
              protected router: Router,
              protected subscriptionService: SubscriptionService,
              protected buyService: BuyService,
              protected m: Model,
              protected http: HttpClient,
              protected workflowPartnerService: WorkflowPartnerService,
              protected customerService: CustomerService,
              protected companyService: CompanyService) {
    super(route, router, subscriptionService, buyService, m, http, workflowPartnerService, customerService, companyService);
  }

  async ngOnInit() {
    super.ngOnInit();
    await this.initWorkflow('downgrade-cu');

    this.checkOnInitPaymentStep(['address']);
    
    this.initialized = true;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  protected checkSelectedProduct(ifStatement: boolean) {
    return +this.model.subscription.users === this.model.cu
      || +this.model.subscription.users < this.model.cu;
  }

  public onDowngradeInfo(e: any) {
    this.navigate(['contact']);
  }

  public onDowngradeInfoBack() {
    // Switch to workflow change cu
    this.router.navigate(['/do', 'change-cu', this.applianceId]);
  }

  public onContact(c: Contact) {
    runInAction(() => {
      this.model.contact = c;
    });
    this.navigate(['address']);
  }
  public onContactBack() {
    this.navigate(['info']);
  }

  public onInvoiceAddressBack() {
    this.navigate(['contact']);
  }

  public onPaymentMethodBack() {
    this.navigate(['address']);
  }

  public onBuy() {
    this.buyService.confirmPartnerQuotation().subscribe(
      (saleOrder: any) => {
        this.navigate(['complete'])
      }
    );
  }
}
